import * as React from "react";
import {
  Datagrid,
  List,
  Show,
  Create,
  ImageField,
  ImageInput,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  BooleanField,
  BooleanInput,
  NumberField,
  NumberInput,
  Edit,
} from "react-admin";

export const CategoriesList = (props) => (
  <List
    {...props}
  >
    <Datagrid>
      <TextField source="name" label="name" />
      <ImageField source="image.src" label="Image"></ImageField>
      <TextField source="description" label="Description" />
      <NumberField source="position" label="Position" />
      <BooleanField source="active" label="Activé ?" />
      <BooleanField source="premiumOnly" label="Premium?" defaultValue={false} />
      <DeleteButton label="" redirect={false} />

      <EditButton label="" />
      <ShowButton />
    </Datagrid>
  </List>
);

export const CategoriesShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="name" label="Name" />
      <ImageField source="image.src" label="Image"></ImageField>
      <TextField
        source="description" label="Description" />
      <NumberField source="position" label="Position" />
      <BooleanField source="active" label="Activé ?" />
      <BooleanField source="premiumOnly" label="Premium?" defaultValue={false} />
    </SimpleShowLayout>
  </Show>
);

export const CategoriesCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" label="Name" />
      <ImageInput source="image" label="Image" >
        <ImageField source="src" title="Thumbnail" />
      </ ImageInput>
      <TextInput source="description" label="Description" />
      <NumberInput source="position" label="Position" defaultValue={0} />
      <BooleanInput source="active" label="Activé" />
      <BooleanInput source="premiumOnly" label="Premium?" />
    </SimpleForm>
  </Create>
);

export const CategoriesEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" label="Name" />
      <ImageInput source="image" label="Image" >
        <ImageField source="src" title="Thumbnail" />
      </ ImageInput>
      <TextInput source="description" label="Description" />
      <NumberInput source="position" label="Position" defaultValue={0} />
      <BooleanInput source="active" label="Activé" />
      <BooleanInput source="premiumOnly" label="Premium?" defaultValue={false} />
    </SimpleForm>
  </Edit>
);

